import { FormattedMessage } from 'react-intl'
import { ApplyOnStatus } from '../../../../../../../../typings'
import { messages } from './messages'

export const applyOnStatusValues = [
  {
    value: ApplyOnStatus.Invoiced,
    label: <FormattedMessage {...messages.invoiced} />,
  },
  {
    value: ApplyOnStatus.PaymentApproved,
    label: <FormattedMessage {...messages.paymentApproved} />,
  },
]
